import { fadeInAnimation } from './../../../../../shared/src/lib/_animations/fade-in.animation';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  CountryDto,
  StateDto,
  LgaDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  ClusterDto,
  ClusterCommunityDto,
  OilBlockDto,
  OilFieldDto,
  CommunityDto,
  DocumentCategoryDto,
  DocumentSubCategoryDto,
  GMOUDto,
  ProjectDto,
  CurrencyDto,
  ProjectStakeholderDto,
  ProjectClusterDto,
  ProgressHistoryReportDto,
  ProgressReportMasterDto,
  ProgressMeetingReportDto,
} from '@cradua/data';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ProjectReferencesService } from '../../services/project-references.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ProjectModalComponent } from 'libs/shared/src/lib/components/project-modal/project-modal.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'mrsoftapps-project-progress',
  templateUrl: './project-progress.component.html',
  styleUrls: ['./project-progress.component.scss'],
  animations: [fadeInAnimation],
  host: { '[@fadeInAnimation]': '' },
})
export class ProjectProgressComponent implements OnInit {
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() projectTypes: ProjectTypeDto[];
  @Input() projectCategories: ProjectCategoryDto[];
  @Input() projectData: GMOUDto;
  @Input() oilBlocks: OilBlockDto[];
  @Input() oilFields: OilFieldDto[];
  @Input() communities: CommunityDto[];
  @Input() countries: CountryDto[];
  @Input() clusters: ClusterDto[];
  @Input() clusterCommunity: ClusterCommunityDto[];
  @Input() projectManagements: ProjectDto[];
  @Input() documentCategory: DocumentCategoryDto[];
  @Input() documentSubCategory: DocumentSubCategoryDto[];
  @Input() currencies: CurrencyDto[];
  @Input() progressHistoryReports: ProgressHistoryReportDto[];
  @Input() progressMasterReports: ProgressReportMasterDto[];
  @Input() progressMeetingReports: ProgressMeetingReportDto[];
  @Input() gmous: GMOUDto[];

  @Output() changeEmit = new EventEmitter<any>();
  @Output() onSaveReportHistory = new EventEmitter<any>();
  @Output() onSaveReportMaster = new EventEmitter<any>();
  @Output() onSaveReportMeeting = new EventEmitter<any>();
  @Output() taskEmit = new EventEmitter<any>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() onDeleteReportMaster = new EventEmitter<any>();
  @Output() onDeleteMeeting = new EventEmitter<any>();

  stakeholders = [
    {
      StakeholderName: 'Elvis Iria',
      StakeholderTypeName: 'General',
      StakeholderRole: 'HR',
      StakeholderAddress: 'Eleme road',
      ProjectId: null,
      StakeholderId: 'BA4289BC-7567-EA11-871F-DC53601E6869',
    },
    {
      StakeholderName: 'Julius Oko',
      StakeholderTypeName: 'General',
      StakeholderRole: 'Graphics',
      StakeholderAddress: 'Eleme road',
      ProjectId: null,
      StakeholderId: 'BA4289BC-7567-EA11-871F-DC53601E6869',
    },
    {
      StakeholderName: 'Daniel Agbor',
      StakeholderTypeName: 'General',
      StakeholderRole: 'Developer',
      StakeholderAddress: 'Eleme road',
      ProjectId: null,
      StakeholderId: 'BA4289BC-7567-EA11-871F-DC53601E6869',
    },
  ];

  projectForm: FormGroup;
  selectOptionForm: FormGroup;
  selectedGmous: any;
  ProjectData: ProjectDto | any;
  status = false;
  searchClusterValue = '';
  searchStakeholderValue = '';
  selectedValue: ProjectDto;
  genericFieldLabel: string;
  genericBlockLabel: string;
  selectedProject: ProjectDto[];
  selectedProjectId: string;
  totalAmountPaid: any;
  isAddReportMaster = false;
  filteredDelete = [];
  @ViewChild('stake', { static: false }) stake: ElementRef;
  progressMasterForm: FormGroup;
  progressMeetingForm: FormGroup;
  newObject: any[] & ProjectStakeholderDto[];
  newClusterObject: any[] & ProjectClusterDto[];
  searchedClusters: ClusterDto[];
  isAddCluster = false;
  filteredDeleteMeeting = [];
  isExpanded = false;
  CreatedById = '49a7b97a-e0b2-49c8-a878-adc753540e2n';
  SubscriberId = '49a7b97a-e0v2-49c8-u078-add753540e2a';
  SiteId = '49a7b97a-e0b2-49c8-a079-add753540e2n';
  filteredProjectMeetingReports: ProgressMeetingReportDto[];
  filteredProgressMasters: ProgressReportMasterDto[];

  constructor(
    private fb: FormBuilder,
    private projectRefService: ProjectReferencesService,
    public matDialog: MatDialog
  ) {}

  ngOnInit() {
    if (this.selectedProjectId) {
      this.selectedProjectValue(this.selectedProjectId);
    }
    this.selectFormValidate();
    this.progressFormArray();
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.

    this.filterProjectModal();
  }

  selectFormValidate() {
    this.selectOptionForm = this.fb.group({
      GMOUTypeId: [''],
      GMOUId: [''],
      ProjectId: [''],
    });
  }

  onClick(): void {
    this.stake.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  progressFormArray() {
    this.progressMasterForm = this.fb.group({
      ProgressMasters: this.fb.array([]),
    });

    this.progressMeetingForm = this.fb.group({
      ProgressMeetings: this.fb.array([]),
    });
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  setProgressMaster() {
    const control = this.progressMasterForm.controls
      .ProgressMasters as FormArray;
    this.filteredProgressMasters.forEach((item) => {
      control.push(
        this.fb.group({
          ReportTitle: item.ReportTitle,
          ProgressReportDescription: item.ProgressReportDescription,
          ReportedBy: item.ReportedBy,
          ProgressReportTie: item.ProgressReportTie,
          ProjectId: item.ProjectId,
          DateReported: item.DateReported,
          id: item.id,
        })
      );
    });
  }

  setProjectMeeting() {
    const control = this.progressMeetingForm.controls
      .ProgressMeetings as FormArray;
    this.filteredProjectMeetingReports.forEach((item) => {
      control.push(
        this.fb.group({
          MeetingReportTitle: item.MeetingReportTitle,
          MeetingReportDescription: item.MeetingReportDescription,
          ProjectId: item.ProjectId,
          ReportedBy: item.ReportedBy,
          DateReported: item.DateReported,
          id: item.id,
        })
      );
    });
  }

  deleteProgressMaster(index: number, value, event) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.progressMasterForm.controls
          .ProgressMasters as FormArray;
        control.removeAt(index);

        if (value.id !== undefined) {
          this.filteredDelete.push(value.id);
          this.isAddReportMaster = true;
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  deleteProjectMeeting(index: number, value, event) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.progressMeetingForm.controls
          .ProgressMeetings as FormArray;
        control.removeAt(index);

        if (value.id !== undefined) {
          this.filteredDeleteMeeting.push(value.id);
          this.isAddReportMaster = true;
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  StakeHolderAlertMessage(name, message) {
    return `
      <div style="color:#04012d; font-size: 16px; margin: 2px;">
      <strong>${name}</strong>
      </div>
      <div>
      ${message}
      </div>
      `;
  }

  saveReportMaster() {
    if (this.filteredDelete.length !== 0) {
      this.onDeleteReportMaster.emit(this.filteredDelete);
    }
  }

  saveReportMeeting() {
    if (this.filteredDeleteMeeting.length !== 0) {
      this.onDeleteMeeting.emit(this.filteredDeleteMeeting);
    }
  }

  filterProjectModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '400px';
    dialogConfig.width = '30%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      name: 'selectOptions',
      projects: this.projectManagements,
      projectCategories: this.projectCategories,
      projectTypes: this.projectTypes,
      selectedProject: this.selectedValue,
      gmous: this.gmous,
    };
    this.isExpanded = false;
    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.selectProject(result);
        this.isExpanded = true;
      }
    });
  }

  openCreateProgressReportModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '700px';
    dialogConfig.width = '80%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      name: 'createProjectHistory',
      projects: this.projectManagements,
      selectedProject: this.selectedValue,
      progressHistoryReports: this.progressHistoryReports,
      progressReportMasters: this.progressMasterReports,
    };

    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.onSaveReportHistory.emit(result.HistoryReport);
        this.onSaveReportMaster.emit(result.MasterReport);
      }
    });
  }

  openCreateProgressMeetingReportModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '500px';
    dialogConfig.width = '50%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      name: 'createProjectMeeting',
      projects: this.projectManagements,
      selectedProject: this.selectedValue,
      progressMeetingReports: this.progressMeetingReports,
    };

    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.onSaveReportMeeting.emit(result);
      }
    });
  }

  openViewProgressMeetingReportModal(value) {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '600px';
    dialogConfig.width = '40%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      name: 'viewProjectMeeting',
      meetingReport: value.value,
    };

    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.onSaveReportMeeting.emit(result);
      }
    });
  }

  openViewProgressMasterReportModal(value) {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '600px';
    dialogConfig.width = '40%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      name: 'viewProjectMaster',
      masterReport: value.value,
      selectedReportHistories: this.filteredReportHistory(
        value.value.ProgressReportTie
      ),
    };

    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.onSaveReportMaster.emit(result);
      }
    });
  }

  filteredReportHistory(id) {
    return this.progressHistoryReports.filter(
      (item) => item.ProgressReportTie.toLowerCase() === id.toLowerCase()
    );
  }

  /* Handle form errors in Angular 8 */
  public errorHandling = (control: string, error: string) => {
    return this.projectForm.controls[control].hasError(error);
  };

  getCurrencyName(id) {
    return this.projectRefService.currencyName(this.currencies, id);
  }

  selectProjectType(event) {
    this.selectedGmous = this.gmous.filter(
      (item) => item.GMOUTypeId === event.value
    );
  }

  selectGMOU(id: string) {
    this.selectedProject = this.projectManagements.filter(
      (item) => item.GMOUId === id
    );
  }

  selectedProjectValue(id) {
    this.selectedValue = this.projectManagements.find((item) => item.id === id);
  }

  filteredProjectMeetingReport(id: string) {
    this.filteredProjectMeetingReports = this.progressMeetingReports.filter(
      (item) => item.ProjectId.toLowerCase() === id.toLowerCase()
    );

    const control = this.progressMeetingForm.controls
      .ProgressMeetings as FormArray;
    if (this.filteredProjectMeetingReports.length > 0) {
      this.clearFormArray(control);
      this.setProjectMeeting();
    } else {
      this.clearFormArray(control);
    }
  }

  filteredProjectMasterReport(id: string) {
    this.filteredProgressMasters = this.progressMasterReports.filter(
      (item) => item.ProjectId.toLowerCase() === id.toLowerCase()
    );

    const control = this.progressMasterForm.controls
      .ProgressMasters as FormArray;
    if (this.filteredProgressMasters.length > 0) {
      this.clearFormArray(control);
      this.setProgressMaster();
    } else {
      this.clearFormArray(control);
    }
  }

  selectProject(id: string) {
    const value: ProjectDto = this.projectManagements.find(
      (item) => item.id === id
    );
    if (value) {
      this.selectedValue = value;
      this.filteredProjectMasterReport(id);
      this.filteredProjectMeetingReport(id);
      this.selectedProjectId = value.id;

      this.ProjectData = {
        id: value.id,
        ProjectTitle: value.ProjectTitle,
        Description: value.Description,
        GMOUCategoryId: this.projectRefService.projectCategoryName(
          this.projectCategories,
          value.GMOUCategoryId
        ),
        GMOUTypeId: this.projectRefService.projectTypeName(
          this.projectTypes,
          value.GMOUTypeId
        ),
        Lgas: this.projectRefService.getLgaArray(this.lgas, value.LGAId),
        States: this.projectRefService.getStateArray(
          this.states,
          value.StateId
        ),
        OilBlocks: this.projectRefService.getOilBlockArray(
          this.oilBlocks,
          value.OilBlocId
        ),
        OilFields: this.projectRefService.getOilFieldArray(
          this.oilFields,
          value.OilFieldId
        ),
        Budget: value.Budget,
        EndDate: value.EndDate,
        StartDate: value.StartDate,
        Executor: value.Executor,
        GMOUId: value.GMOUId,
      };

      if (this.oilFields.length > 0) {
        this.genericFieldLabel = this.oilFields[0].LabelName;
        this.genericBlockLabel = this.oilBlocks[0].LabelName;
      }

      if (value.projectPayments.length > 0) {
        this.totalAmountPaid = value.projectPayments
          .filter((x) => x.ProjectId === value.id)
          .map((item) => item.Amount)
          .reduce((prev, next) => prev + next);
      } else {
        this.totalAmountPaid = 0;
      }
      this.status = true;
    }
  }

  getState(id) {
    const selectedLga = this.lgas.find((item) => item.id === id);

    if (!selectedLga) {
      return;
    }

    const selectedState = this.states.find(
      (item) => item.id === selectedLga.StateId
    );

    if (!selectedState) {
      return;
    }

    return selectedState;
  }

  getProjectCategory(id) {
    const selectedType = this.projectTypes.find((item) => item.id === id);
    if (!selectedType) {
      return;
    }

    const selectedCategory = this.projectCategories.find(
      (item) => item.id === selectedType.ProjectCategoryId
    );

    if (!selectedCategory) {
      return;
    }

    return selectedCategory;
  }

  getOilBlock(id) {
    const selectedOilField = this.oilFields.find((item) => item.id === id);
    if (!selectedOilField) {
      return;
    }

    const selectedOilBlock = this.oilBlocks.find(
      (item) => item.id === selectedOilField.OilBlockId
    );

    if (!selectedOilBlock) {
      return;
    }

    return selectedOilBlock;
  }

  onSubmit(formValue: ProjectDto) {
    const selectedProjectType = this.getProjectCategory(formValue.GMOUTypeId);
    formValue.GMOUCategoryId = selectedProjectType.id;
    formValue.OilBlocId = this.selectedValue.OilBlocId;
    formValue.OilFieldId = this.selectedValue.OilFieldId;
    formValue.StateId = this.selectedValue.OilFieldId;
    formValue.LGAId = this.selectedValue.LGAId;

    this.changeEmit.emit(formValue);
  }
}
